// Must stay dependency-free: importing widget styles here would pull every
// widget CSS module into whatever chunk reaches for this.
//
// `revert` would leave an inherited property at whatever the parent computed; only
// `initial` cuts the chain. Every surface with text re-declares its own font, even
// where a sibling stylesheet in the same shadow root already did: the last copy of
// this rule to land resets the host again.
//
// Never `!important`: it would beat the inline pin applyHostZIndex writes on the host.
export const HOST_RESET_CSS = ':host { all: initial; box-sizing: border-box; display: block; }';
